// import { memo } from 'react'

const getAvatarText = (name) => {
  const token = name.split(' ')
  if (token.length === 1) {
    return token[0].substring(0, 2).toUpperCase()
  } else {
    const first = token[0].substring(0, 1).toUpperCase()
    const second = token[1].substring(0, 1).toUpperCase()
    return `${first}${second}`
  }
}

export default getAvatarText



// WEBPACK FOOTER //
// ./src/Lib/GetAvatarText.js